(function ($) {
  $(window).on('load', function(){
      if($(window).innerWidth() <= 1024 && $('body').hasClass('template-collection') && $('div').hasClass('collection-lunettes')){
        $("li.product--image").remove()
      }  
  });
  $(document).ready(function () {
    $(window).scroll(function(){
        if($(this).scrollTop() > 0){
          $('.halo-sticky-toolbar-mobile').hide();
        }
        else{
          if($(window).innerWidth() <= 1024){
            $('.halo-sticky-toolbar-mobile').show();
          }
        }
    });
    $(".desktopMenu-toggle").click(function (e) {
      e.stopPropagation();
      $(".menu-desktop-custom").toggleClass("active");
      $("body").toggleClass("desktop-menu-custom-open");
      $(".overlay-custom-menu").toggleClass("active");
    });
    $('.grid-product-custom .box-product').each(function () {
        if ($.trim($(this).html()) === '') {
            $(this).css('display', 'none');
        }
    });
     if ($(window).width() < 1025) {
        $(".header-nav-plain .wrap-search .icon-search-custom").click(function (e) {
           $("body").addClass("open_search_mobile");
        })
     }
    $(document).click(function (event) {
      if (
        !$(event.target).closest(".menu-desktop-custom, .desktopMenu-toggle")
          .length
      ) {
        $(".nav-menu-custom .menu-item.eight .wrap-content .menu-child.item-menu-page-parent .menu-item-child-child").hide();
         setTimeout(function () {
             $(".nav-menu-custom .menu-item.eight .wrap-content .menu-child.item-menu-page-parent .menu-item-child-child").removeAttr("style");
        }, 500);
       
        $(".menu-desktop-custom").removeClass("active");
        $(".nav-menu-custom .wrap-content").removeClass("active").removeAttr("style");
        $(".nav-menu-custom .wrap-title").removeClass("active");
        $(".nav-menu-custom .wrap-menu").removeClass("active-child");
        $(".nav-menu-custom .wrap-title .icon-arrow ").removeClass("rotate");
        $("body").removeClass("desktop-menu-custom-open");
        $(".overlay-custom-menu").removeClass("active");
      }
    });
    $(document).ready(function () {
      $(".menu-desktop-custom .icon-close-custom").click(function (e) {
        $(".nav-menu-custom .menu-item.eight .wrap-content .menu-child.item-menu-page-parent .menu-item-child-child").hide();
        setTimeout(function () {
             $(".nav-menu-custom .menu-item.eight .wrap-content .menu-child.item-menu-page-parent .menu-item-child-child").removeAttr("style");
        }, 500);
        $(".menu-desktop-custom").removeClass("active");
        $(".nav-menu-custom .wrap-content").removeClass("active").removeAttr("style");
        $(".nav-menu-custom .wrap-title").removeClass("active");
        $(".nav-menu-custom .wrap-menu").removeClass("active-child");
        $(".nav-menu-custom .wrap-title .icon-arrow ").removeClass("rotate");
        $("body").removeClass("desktop-menu-custom-open");
        $(".overlay-custom-menu").removeClass("active");
      });
    });
    $(".section-custom .wrap-product .box-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      dots: true,
      infinite: true,
    });
    if( $(window).width() <= 960 ){
      $(".footer-content-top .wrap-box-content").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        dots: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
   

    $(".list-product-look").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: true,
      dots: false,
      infinite: true,
    });
    $(".section-product-in-page .wrap-product .box-product .product-item .card-product .card-product__wrapper .card-media .product-slider").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: true,
      swipeToSlide: true,
      swipe: true,
      touchMove: true,
      fade: false,
      draggable: true,
      mobileFirst: true
    });
    $(".collection #main-collection-product-grid .product .card-product .card-product__wrapper .card-media .product-slider").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: true,
      swipeToSlide: true,
      swipe: true,
      touchMove: true,
      fade: false,
      draggable: true,
      mobileFirst: true
    });
    $(".grid-product-custom .box-product .product .card-product .card-product__wrapper .card-media .product-slider").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      arrows: true,
      swipeToSlide: true,
      swipe: true,
      touchMove: true,
      fade: false,
      draggable: true,
      mobileFirst: true
    });

    const initSlider = () => {
      const slider = $(
        ".wrap-product-recomment .product .product-item .card-product .card-product__wrapper .card-media .slider-custom"
      );

      if (slider.length > 0 && !slider.hasClass("slick-initialized")) {
        slider.slick({
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          arrows: true,
          adaptiveHeight: true,
          responsive: [
           
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                }
            },
          ],
        });
      }
    };
    
    const initSliderSearch = () => {
      const sliderSearch = $(
        ".predictive-search .quickSearchResults .predictive-search__results-list .products-grid .product .product-item .card-product .card-product__wrapper .card-media .slider-custom"
      );

      if (
        sliderSearch.length > 0 &&
        !sliderSearch.hasClass("slick-initialized")
      ) {
        sliderSearch.slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3000,
          arrows: false,
        });
      }
    };

    const checkSlider = setInterval(() => {
      if ($(".slider-custom").length > 0) {
        initSlider();
        clearInterval(checkSlider);
      }
      
      if (
        $(
          ".predictive-search .quickSearchResults .predictive-search__results-list .products-grid .product .product-item .card-product .card-product__wrapper .card-media .slider-custom"
        ).length > 0
      ) {
        initSliderSearch();
        clearInterval(checkSlider);
      }
    }, 500);

    let searchCheckInterval;
    $(".search-modal__form .search__input").on(
      "input click",
      function () {
        if (searchCheckInterval) clearInterval(searchCheckInterval);

        searchCheckInterval = setInterval(() => {
          initSliderSearch();
        }, 500);
      }
    );

    
    
    $(".show-modal .button-modal-livraison").on("click", function () {
      $(".modal-livraison, .modal-overlay-livraison").fadeIn();
      $("body").addClass("no-scroll-livraison");
    });

    $(".close-modal-livraison, .modal-overlay-livraison").on(
      "click",
      function () {
        $(".modal-livraison, .modal-overlay-livraison").fadeOut();
        setTimeout(() => {
          $("body").removeClass("no-scroll-livraison");
        }, 500);
      }
    );
  });
  $(document).ready(function () {
    function initSlick() {
        $(".halo-search-content .resultListing .productListing .product .product-item .card-product .card-product__wrapper .card-media .product-slider").each(function () {
            if (!$(this).hasClass('slick-initialized')) {
                $(this).slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    arrows: false,
                });
            }
        });
    }
    function initSlickCollection() {
        $(".collection #main-collection-product-grid .product .card-product .card-product__wrapper .card-media .product-slider").each(function () {
            if (!$(this).hasClass('slick-initialized')) {
                $(this).slick({
                   dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 4000,
                    arrows: false,
                    swipeToSlide: true,
                    swipe: true,
                    touchMove: true,
                    fade: false,
                    draggable: true,
                    mobileFirst: true
                });
            }
        });
    }
    initSlick();
    initSlickCollection();

    let timeout;
    let timeoutCollection;
    const observer = new MutationObserver(function (mutations) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            initSlick();
        }, 300);
    });
    const observerCollection = new MutationObserver(function (mutations) {
        clearTimeout(timeoutCollection);
        timeoutCollection = setTimeout(() => {
            initSlickCollection();
        }, 300);
    });

    const targetNodeCollection = document.querySelector(".collection #main-collection-product-grid");
    const targetNode = document.querySelector(".halo-search-content .resultListing .productListing");
    if (targetNode) {
        observer.observe(targetNode, { childList: true, subtree: true });
    }
    if (targetNodeCollection) {
        observerCollection.observe(targetNodeCollection, { childList: true, subtree: true });
    }
});

$(document).ready(function() {
  if (window.location.hash === "#recover") {
      var target = $("#recover");
      if (target.length) {
        $("html, body").animate({
          scrollTop: target.offset().top - 120
        }, 100);
      }
  }
});



})(jQuery);
